<script setup>
import { inject } from 'vue';

// Components
import VacancyCard from './Vacancy/VacancyCard.vue';

const props = defineProps({
    title: String,
    vacancies: Object,
});

const route = inject('route');
</script>

<template>
    <div class="bg-gray-lighter">
        <div class="container flex flex-col items-center py-12 md:py-16" v-if="title">
            <h2 class="" v-html="title" v-if="title"></h2>

            <div class="w-full md:w-8/12">
                <div class="grid w-full gap-4 mb-6" v-if="vacancies.length">
                    <article v-for="(vacancy, i) in vacancies" :key="i" class="flex flex-col col-span-1">
                        <VacancyCard :key="i" :vacancy="vacancy"
                            :href="route('public.vacancies.show', { slug: vacancy.page_slug })" />
                    </article>
                </div>
            </div>
        </div>
    </div>
</template>
